// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HhsCreateEnrollmentRequest {
    static getAttributeTypeMap() {
        return HhsCreateEnrollmentRequest.attributeTypeMap;
    }
}
HhsCreateEnrollmentRequest.discriminator = undefined;
HhsCreateEnrollmentRequest.additionalProperties = false;
HhsCreateEnrollmentRequest.attributeTypeMap = [
    {
        "name": "hubInitiator",
        "baseName": "hubInitiator",
        "type": "HhsInitiator"
    },
    {
        "name": "source",
        "baseName": "source",
        "type": "HhsSource"
    },
    {
        "name": "medication",
        "baseName": "medication",
        "type": "HhsMedication"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "HhsPatient"
    },
    {
        "name": "medicalPayors",
        "baseName": "medicalPayors",
        "type": "Array<HhsMedicalPayor>"
    },
    {
        "name": "pharmacyPayors",
        "baseName": "pharmacyPayors",
        "type": "Array<HhsPharmacyPayor>"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "HhsPrescriber"
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": "HhsAttestations"
    },
    {
        "name": "thirdPartyEnrollmentId",
        "baseName": "thirdPartyEnrollmentId",
        "type": "string"
    },
];
//# sourceMappingURL=hhsCreateEnrollmentRequest.js.map